<template>
  <div>
    <Card>
      <p slot="title"> Nota Transaksi Giro</p>
      <Row type="flex" justify="space-between" class="code-row-bg">
        <Col span="6">
        <ButtonGroup class="custom-group-parent">
          <Button class="custom-group">Tgl. Giro</Button>
          <Date-picker v-model="filterGiroDate" style="width: 180px;" type="daterange" format="yyyy-MM-dd"
            @on-change="updateFilter">
          </Date-picker>
        </ButtonGroup>
        </Col>

        <Col span="6">
        <ButtonGroup class="custom-group-parent">
          <Button class="custom-group">Kode Nota</Button>
          <Input style="width: 250px;" v-model="filterNoteCode" @on-keyup="updateFilter"></Input>
        </ButtonGroup>
        </Col>

        <Col span="6">
        <ButtonGroup class="custom-group-parent">
          <Button class="custom-group">Marking</Button>
          <Select style="width: 250px;" v-model="markingIdSelected" filterable clearable
            :remote-method="getMarkingByCode" :loading="isLoadingMarking" @on-change="updateFilter">
            <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">{{ option.label }}</Option>
          </Select>
        </ButtonGroup>
        </Col>

        <Col span="2">
        <Button type="primary" icon="ios-search" @click="getTransactionNote" :disabled="!isSearchShow">
          <span>Cari</span>
        </Button>
        </Col>

        <Col span="2">
        <Spin size="large" v-show="isLoadingMarking"></Spin>
        </Col>
      </Row>

      <br />

      <!-- <Card>
        <cHotTransactionNoteGiro v-if="transactionNoteData.length > 0"
            :dataHot="transactionNoteData">
        </cHotTransactionNoteGiro>
      </Card> -->

      <Card>
        <Table :columns="columnsDataTable" :data="transactionNoteData" @on-selection-change="onSelectionChange"></Table>
      </Card>
    </Card>

    <div class="footer" v-show="transactionNotePrint.length > 0">
      <Button type="success" @click="modalConfirmMultiplePrint = true" icon="printer" size="small">
        <span>Cetak {{ transactionNotePrint.length }} data</span>
      </Button>
    </div>

    <!-- table-sheet hidden -->
    <div id="table-to-excel" ref="sheetsDataTableList" hidden></div>

    <!-- Modal Confirm Multiple Print -->
    <Modal v-model="modalConfirmMultiplePrint" width="50rem">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span>Konfirmasi</span>
      </p>
      <div style="text-align:left; display: flex;">
        <div v-for="data in transactionNotePrint">
          <Tag color="blue">{{ data.noteCode }}</Tag>
        </div>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long icon="printer" @click="notePrint(transactionNotePrint)">Cetak</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
// import cHotTransactionNoteGiro from '@/components/giro/cHotTransactionNoteGiro';

import _ from 'lodash'
import moment from 'moment'
import * as XLSX from 'xlsx'

const numeral = require('numeral');

export default {
  // components: {
  //   cHotTransactionNoteGiro
  // },
  data() {
    return {
      filterGiroDate: null,
      filterNoteCode: '',
      markingIdSelected: '',
      isSearchShow: false,
      optionMarkings: [],
      isLoadingMarking: false,
      columnsDataTable: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'Kode Nota',
          key: 'noteCode'
        },
        {
          title: 'Marking',
          key: 'marking',
        },
        {
          title: 'Marking Grup',
          key: 'markingGroup',
        },
        {
          title: 'Tgl. Terima Giro',
          key: 'giroDate',
        },
        {
          title: 'Tgl. Jatuh Tempo',
          key: 'paymentDate',
        },
        {
          title: 'Nomor Giro',
          key: 'giroNumber',
        },
        {
          title: 'Nominal Giro',
          key: 'giroNominal',
        },
        {
          title: 'Bank',
          key: 'accountName',
        },
      ],
      transactionNoteData: [],
      transactionNotePrint: [],
      modalConfirmMultiplePrint: false
    }
  },
  methods: {
    showDateFormatted: function (stringToFormat) {
      let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
      return moment(dateToFormat).format("DD MMM YYYY")
    },
    getMarkingByCode: _.debounce(
      function (query) {
        if (query !== '') {
          this.isLoadingMarking = true;
          HTTP
            .post('marking/getBySnapshot', {
              markingHeaderId: query
            })
            .then(response => {
              this.isLoadingMarking = false;
              let data = response.data;

              const list = data.map(item => {
                return {
                  value: item.markingheaderid,
                  label: item.markingheadercode
                };
              });

              this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
            })
            .catch(e => {
              this.isLoadingMarking = false;
              this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
              });
            })
        } else {
          this.optionMarkings = [];
        }
      }, 400
    ),

    updateFilter: function () {
      let fTrxDate = this.filterGiroDate;
      let fNoteCode = this.filterNoteCode;
      let fMarkingSelected = this.markingIdSelected;

      if ((fTrxDate != '' && fTrxDate != null) || fNoteCode != '' || (fMarkingSelected != '' && fMarkingSelected != undefined)) {
        this.isSearchShow = true
      } else {
        this.isSearchShow = false
      }
    },

    getTransactionNote: function () {
      this.$Loading.start();

      // let fTrxDate = this.filterGiroDate != "" && this.filterGiroDate != null ? moment(this.filterGiroDate, 'YYYY-MM-DD').format("YYYY-MM-DD") : null;
      let fStartDate = null;
      let fEndDate = null;
      if (this.filterGiroDate[0] != "" && this.filterGiroDate[0] != null) {
        fStartDate = moment(this.filterGiroDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
        fEndDate = moment(this.filterGiroDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
      }
      let fNoteCode = this.filterNoteCode != "" ? this.filterNoteCode.toUpperCase() : null;
      let fMarkingSelected = this.markingIdSelected != "" && this.markingIdSelected != undefined ? this.markingIdSelected : null;

      let payload = {
        isCancel: false,
        isTrxNote: true,
        // giroDate: fTrxDate,
        startGiroDate: fStartDate,
        endGiroDate: fEndDate,
        noteCode: fNoteCode,
        markingHeaderId: fMarkingSelected
      }

      this.transactionNoteData = [];
      HTTP.post('giro/search', payload)
        .then(response => {
          let parent = this;
          let receivableGiro = [];
          console.log({ response });

          _.forEach(response.data, function (value, index) {
            let noteCode = value.noteCode
            let receivableId = value.creditReceivableId
            let paymentId = value.paymentId
            let giroId = value.id
            let giroDate = parent.showDateFormatted(value.giroDate)
            let giroNumber = value.giroNumber
            let giroNominal = "Rp. " + numeral(value.giroNominal).format('0,0')
            let paymentDate = parent.showDateFormatted(value.paymentDate)
            let bankAccountId = value.bank_account != null ? value.bank_account.id : ''
            let accountName = value.bank_account != null ? value.bank_account.accountName : ''
            let dueDate = moment(value.dueDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD")
            let isClearing = value.isClearing
            let isCancel = value.isCancel
            let giroHistory = value.giro_history
            let description = value.receivable != null ? value.receivable.description : ''
            let partai = value.receivable != null ? value.receivable.invoice.packaging_list.container_loading.containercode : ''
            let marking = value.marking_header != null ? value.marking_header.markingheadercode : '-'
            let markingHeaderId = value.marking_header != null ? value.marking_header.markingheaderid : null
            let markingGroup = value.marking_group != null ? value.marking_group.code : '-'
            let markingGroupId = value.marking_group != null ? value.marking_group.id : null
            let dueNotes = value.dueNotes
            let cancelNotes = value.cancelNotes
            let file = value.filename
            let markingHeaderCode = null
            let payment = value.payment

            if (value.marking_header != null) {
              markingHeaderCode = value.marking_header.markingheadercode
            } else if (value.marking_group != null) {
              markingHeaderCode = value.marking_group.code
            }

            let paymentAllocate = [{
              invoicefee: value.receivable != null ? value.receivable.invoice.invoicefee : '',
              invoiceDueId: value.invoice_due != null ? value.invoice_due.id : '',
              allocateAmount: value.giroNominal,
              receivableRemaining: value.invoice_due != null ? value.invoice_due.receivableRemaining : '',
              useDepositAmount: 0,
            }]

            let clearingPaymentAdd = {
              markingHeaderId: value.markingHeaderId,
              amount: value.giroNominal,
              transactionDate: moment(value.giroDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
              description: 'KU ' + accountName + ' P. ' + partai + ' - ' + description,
              accountNumber: value.bank_account != null ? value.bank_account.id : '',
              depositAmount: 0,
              paymentAllocates: paymentAllocate,
              depositType: '',
              category: 'pay',
              giroId: giroId
            }

            let rGiro = {
              noteCode: noteCode,
              markingHeaderId: markingHeaderId,
              markingGroupId: markingGroupId,
              marking: marking,
              markingGroup: markingGroup,
              markingHeaderCode: markingHeaderCode,
              receivableId: receivableId,
              paymentId: paymentId,
              giroId: giroId,
              giroDate: giroDate,
              giroNumber: giroNumber,
              giroNominal: giroNominal,
              paymentDate: paymentDate,
              bankAccountId: bankAccountId,
              accountName: accountName,
              dueDate: dueDate,
              isClearing: isClearing,
              isCancel: isCancel,
              giroHistory: giroHistory,
              clearingPaymentAdd: clearingPaymentAdd,
              dueNotes: dueNotes,
              cancelNotes: cancelNotes,
              file: file,
              payment: payment,
              description: description
            }
            receivableGiro.push(rGiro);
          });

          this.transactionNoteData = receivableGiro;

          this.$Loading.finish();
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        });
    },

    onSelectionChange: function (selection) {
      this.transactionNotePrint = selection
    },
    notePrint(dataTrx) {
      console.log({ dataTrx });
      // set table html
      let tempData = `
            <table id="exportedTable" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides" border="2">
              <thead valign="top">
                <tr> <th colspan='6' style="font-weight: bold; font-family: Verdana; font-size: 20px; color: red;"> GIRO JKT </th> </tr>
                <tr> <th colspan='6' style="font-weight: bold; font-family: Verdana; font-size: 20px; color: red;"> ${dataTrx[0].giroDate} </th> </tr>
                <tr> <th colspan='6' style="font-weight: bold; font-family: Verdana; font-size: 20px; color: red;"> ${dataTrx[0].giroNumber}</th> </tr>
                <tr><th></th><th></th><th></th><th></th><th></th><th></th></tr>
                <tr><th></th><th></th><th></th><th></th><th></th><th></th></tr>
                <tr><th></th><th></th><th></th><th></th><th></th><th></th></tr>
                <tr><th></th><th></th><th></th><th></th><th></th><th></th></tr>
              </thead>

              <tbody>`;

      dataTrx.forEach(el => {
        // let formatedDate = moment(el.transactionDate).format('YYYY-MM-DD');

        tempData += `
                    <tr>
                      <td colspan="6">
                        <table>
                          <thead valign="top">
                            <tr>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black; font-weight: bold; font-family: Verdana; font-size: 8px; color: #3333cc;"> ${el.marking} </th>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black; font-weight: bold; font-family: Verdana; font-size: 13px; color: #3333cc;"> ${el.noteCode} </th>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black;"></th>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black;"></th>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black;"></th>
                              <th style="border: 1px solid black; font-weight: bold; font-family: 'Times New Roman'; font-size: 12px;">PARAF</th>
                            </tr>
                          </thead>

                          <tr>
                            <td style="font-family: 'Times New Roman'; font-size: 12px; color: #ff0000"> ${el.giroDate} </td>
                            <td style="font-family: 'Times New Roman'; font-size: 12px; color: #ff0000"> ${el.description} </td>
                            <td></td>
                            <td style="font-family: 'Times New Roman'; font-size: 12px; color: #ff0000"> ${el.giroNominal} </td>
                            <td></td>
                            <td style="border-left: 1px solid black; border-right: 1px solid black;"></td>
                          </tr>

                          <tr>
                            <td></td><td></td><td></td><td>
                            </td><td></td><td style="border-left: 1px solid black; border-right: 1px solid black;"></td>
                          </tr>`;

        el.payment.map(function (payment) {
          payment.payment_allocate.map(function (payment_allocate) {
            tempData +=
              '<tr>' +
              '<td></td>' +
              '<td>' + payment_allocate.invoice_due_detail.receivable_detail.description + '</td>' +
              '<td></td>' +
              '<td></td>' +
              '<td>' + "Rp. " + numeral(payment_allocate.allocateAmount).format('0,0') + '</td>' +
              '<td style="border-left: 1px solid black; border-right: 1px solid black;"></td>' +
              '</tr>';
          });
        })

        tempData += `
                          <tr style="border-bottom: 1px solid black;">
                            <td></td><td></td><td></td><td>
                            </td><td></td><td style="border-left: 1px solid black; border-right: 1px solid black;"></td>
                          </tr>

                        </table>
                      </td>
                    </tr>

                    <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>`;
      });

      tempData += `</tbody></table>`;

      this.$refs.sheetsDataTableList.innerHTML = tempData;


      // exec table to excel
      var tableToExcel = (function () {
        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>';
        var base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) };
        var format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) };

        return function (table, name) {
          if (!table.nodeType) table = document.getElementById(table);
          var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
          var html = format(template, ctx);
          var blob = new Blob([html], { type: 'application/vnd.ms-excel' });
          var url = URL.createObjectURL(blob);

          var a = document.createElement('a');
          a.href = url;
          a.download = "Nota Transaksi Giro - " + dataTrx[0].noteCode + " - " + moment(new Date()).format("DDMMYYhhmmss") + '.xls';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })();
      tableToExcel('exportedTable', 'NT GIRO');
    }
  },
  mounted() {
    this.$Loading.config({
      color: '#ffffff',
      failedColor: '#f0ad4e',
      height: 10
    });

    // this.getTransactionNote()
  }
}

</script>



// WEBPACK FOOTER //
// GiroTransactionNote.vue?5c592bbb